export type Entries<T> = { [K in keyof T]: [K, T[K]] }[keyof T];

export const strictEntries: <T extends object>(obj: Partial<T>) => ReadonlyArray<Entries<T>> =
  Object.entries;
